import React from "react";
import { useFormikContext } from "formik";
import { debounce } from "lodash";

const FormAutoSave = ({ debounceMs }) => {
    const formik = useFormikContext();
    
    const debouncedSubmit = React.useCallback(
        debounce(
            () =>
                formik
                    .submitForm(),
            debounceMs
        ),
        [debounceMs, formik.submitForm]
    );

    React.useEffect(() => {
        formik.dirty && debouncedSubmit();
    }, [debouncedSubmit, formik.dirty, formik.values]);

    return (
        <>
            {!!formik.isSubmitting ? <i className="fa-solid fa-spinner"></i> : ""}           
        </>
    );
};

export default FormAutoSave;